(() => {
  if (customElements.get('custom-testimonial')) return;

  class CustomTestimonial extends HTMLElement {
    connectedCallback() {
      this.selectBlock = this.selectBlock.bind(this);
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.configure(), 150);
      };
      this.loadAttempts = 0;
      this.onReady = () => this.waitForSplide();
      this.addEventListener('shopify:block:select', this.selectBlock);
      window.addEventListener('resize', this.onResize);
      this.waitForSplide();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
    }

    waitForSplide() {
      if (!this.isConnected) return;
      if (window.Splide) {
        clearTimeout(this.splideTimer);
        this.configure();
        return;
      }
      if (this.loadAttempts++ < 50) this.splideTimer = setTimeout(() => this.waitForSplide(), 100);
    }

    configure() {
      if (!this.isConnected || !window.Splide) return;
      const root = this.querySelector('.custom-testimonial__slider');
      if (!root) return;
      const count = root.querySelectorAll('.custom-testimonial__slide').length;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const tablet = !mobile && window.matchMedia('(max-width: 989px)').matches;
      const perPage = Number(mobile ? this.dataset.mobileItems : tablet ? this.dataset.tabletItems : 2) || 1;
      const styles = getComputedStyle(this);
      const peekProperty = mobile ? '--testimonial-peek-mobile' : '--testimonial-peek-tablet';
      const peek = mobile || tablet
        ? (parseFloat(styles.getPropertyValue(peekProperty)) || 0)
        : this.getBoundingClientRect().width * 0.191;
      const gap = parseFloat(styles.getPropertyValue('--testimonial-gap')) || 20;
      const enabled = count > perPage;
      const signature = [perPage, peek, gap, enabled].join(':');
      if (signature === this.signature) return;
      const previousIndex = this.slider?.index;
      this.slider?.destroy(true);
      this.slider = null;
      this.signature = signature;
      if (!enabled) return;

      const start = previousIndex === undefined
        ? (peek > 0 && count >= perPage + 2 ? 1 : 0)
        : Math.min(previousIndex, Math.max(0, count - perPage));
      this.slider = new window.Splide(root, {
        type: 'loop',
        perPage,
        perMove: 1,
        start,
        gap,
        padding: { left: peek, right: peek },
        trimSpace: false,
        rewind: this.dataset.rewind === 'true',
        speed: Number(this.dataset.speed) || 500,
        arrows: true,
        pagination: false,
        autoplay: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        keyboard: false,
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' },
      });
      this.slider.mount();
    }

    selectBlock(event) {
      if (!this.slider) return;
      const slides = Array.from(this.querySelectorAll('.custom-testimonial__slide'));
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) this.slider.go(index);
    }

    disconnectedCallback() {
      clearTimeout(this.resizeTimer);
      clearTimeout(this.splideTimer);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.removeEventListener('shopify:block:select', this.selectBlock);
      this.slider?.destroy(true);
      this.slider = null;
    }
  }

  customElements.define('custom-testimonial', CustomTestimonial);
})();
